import ApiService from "@/api/apiService";
import {CancelToken} from "axios";

export enum AVAILABLE_CONTEXTS {
  DEFAULT = 'default',
  RU = 'country-ru',
  FASHION_APP_US = 'consumer-fashion-app-us',
  MY_ACCOUNT = 'consumer-my-account-app',
}

export interface CreateQrCodeResponse {
  expireDate: string;
  qrCode: string;
  qrCodeUrl: string;
  securityToken: string;
  type: AVAILABLE_CONTEXTS;
  countryCode: string;
  myAccount?: CreateQrCodeResponseMyAccount;
}

interface CreateQrCodeResponseMyAccount {
  [key: string]: string;
}

export interface CheckQrCodeResponse {
  expireDate: string;
  registerStarted: boolean;
}

export default class QRCodeService {

  public static async createQRCode(countryCode: string|null, debugConfig: { isDebugMode: boolean; contextCode?: string | null; countryCode?: string }, cancelToken: CancelToken): Promise<CreateQrCodeResponse> {
    return ApiService.api.post('/admin/qrcode/create', {
      countryCode,
      debugConfig,
    }, {cancelToken}).then(r => r.data);
  }

  public static async checkQRCode(securityToken: string): Promise<CheckQrCodeResponse> {
    return ApiService.api.post('/admin/qrcode/check', {
      securityToken,
    }).then(r => r.data);
  }
}
